import React, { Component } from 'react';
import { ViewTitle } from 'admin-on-rest';
import './style.css';

class Dashboard extends Component { // eslint-disable-line
  render() {
    const iframe = encodeURI(`https://dashboards.pinchos.se?${JSON.stringify(this.props.user)}`);
    return (
      <div className="dashboard-wrapper">
        <ViewTitle style={{ textAlign: 'center' }} title={null} />
        <iframe className="dashboard-iframe" title="dashboard" src={iframe} />
      </div>
    );
  }
}

export default Dashboard;
